<template>
  <section class="content">
    <div class="information-content">
      <div class="form-group" v-show="isAdmin">
        <label>APP ID</label>
        <input
          type="text"
          class="form-control"
          placeholder="Text"
          v-model="formData.appid"
          disabled
        >
      </div>
      <div class="form-group">
        <label>Description</label>
        <input
          type="text"
          class="form-control"
          placeholder="Description"
          v-model="formData.description"
          :disabled="!isSuperAdmin"
        >
      </div>
      <div class="form-group">
        <label>Addonversion</label>
        <input
          type="text"
          class="form-control"
          placeholder="Addonversion"
          v-model="formData.addonversion"
          :disabled="!isSuperAdmin"
        >
      </div>
      <div class="form-group">
        <label>Iosmd5</label>
        <input
          type="text"
          class="form-control"
          placeholder="Iosmd5"
          v-model="formData.iosmd5"
          :disabled="!isSuperAdmin"
        >
      </div>
      <div class="form-group">
        <label>Iosurl</label>
        <input
          type="text"
          class="form-control"
          placeholder="Iosurl"
          v-model="formData.iosurl"
          :disabled="!isSuperAdmin"
        >
      </div>
      <div class="form-group">
        <label>Androidmd5</label>
        <input
          type="text"
          class="form-control"
          placeholder="Androidmd5"
          v-model="formData.androidmd5"
          :disabled="!isSuperAdmin"
        >
      </div>
      <div class="form-group">
        <label>Androidurl</label>
        <input
          type="text"
          class="form-control"
          placeholder="Androidurl"
          v-model="formData.androidurl"
          :disabled="!isSuperAdmin"
        >
      </div>
    </div>
  </section>
</template>
<script>
import api from "../../api";
import utils from "../../utils";

export default {
  name: "device-addon-client-form",
  props: {
    withInitialData: Boolean
  },
  data() {
    return {
      formData: {
        appid: null,
        description: null,
        addonversion: null,
        iosmd5: null,
        iosurl: null,
        androidmd5: null,
        androidurl: null
      },
      isSuperAdmin: utils.checkIsSuperAdmin(),
      isAdmin: utils.checkIsAdmin()
    };
  },
  methods: {
    async fetch() {
      const { appid } = this.$route.query;
      const res = await api.post({
        path: "/deviceaddonclient/get?_type=json",
        data: { appid },
        withLoading: true
      });
      this.formData = res;
    },
    async update() {
      const data = this.formData;
      console.log("data", data);

      const res = await api.post({
        path: `/deviceaddonclient/update?_type=json`,
        data,
        withLoading: true
      });
      console.log("res", res);
    }
  },
  mounted() {
    if (this.$props.withInitialData) {
      this.fetch();
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// DeviceAddonClientForm.vue?62b20cb9